import EmployeesView from "../../../jsx/components/Dashboard/Employees/EmployeesView";

const EmployeesViewWrapper = () => {
  return <EmployeesView />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.admin];

export default constore(EmployeesViewWrapper);
